<template>
    <div class="ordersList">
        <orderThumb></orderThumb>
        <status-tabs
            :status.sync="status"
            :statusList="statusList"
            :funcName="funcName"
        ></status-tabs>
        <platforms
            :platformList="platformList"
            @chiocePlatform="chiocePlatform"
            :status="status"
        ></platforms>
        <search-tool
            ref="searchTool"
            :status="status"
            :statusList="statusList"
            :funcName="funcName"
            :searchForm="searchForm"
            :searchList="searchList"
            :searchForm_transfer="searchForm_transfer"
            :advanceSearchFields="advanceSearchFields"
            listName="orders"
            :loading="loading"
            :menuAuth="menuAuth"
            :inputPlaceholder="inputPlaceholder"
            :selected="selectList.length"
        ></search-tool>
        <div class="table" :style="{ height: height }">
            <el-table
                ref="orderList"
                :data="tableData"
                highlight-current-row
                height="100%"
                @selection-change="handleSelectionChange"
                :cell-style="cellStyle"
            >
                <el-table-column
                    type="selection"
                    align="center"
                    :fixed="checkFixed"
                ></el-table-column>
                <!--
        <el-table-column :label="$t('ordersList.tableName.order_sn')"
                         property="order_sn"
                         align="left">
                </el-table-column>-->
                <el-table-column
                    :label="$t('ordersList.tableName.plt_order_sn')"
                    property="plt_order_sn"
                    align="left"
                    width="170"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <div>
                            <el-tooltip placement="top" v-if="scope.row.gift_message.length > 0">
                                <div slot="content" style="white-space: pre-wrap;" v-html='scope.row.gift_message.split("\\n").join("<br>")'></div>
                            <img
                                class="warning"
                                src="@/assets/image/gift.svg"
                            />
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" content="High risk of fraud detected" placement="top" v-if="scope.row.high_risk == 1">
                            <img
                                class="warning"
                                src="@/assets/image/warning1.svg"
                            />
                            </el-tooltip>
                            <i
                                class="el-icon-s-help"
                                style="color: #fc8540"
                                v-if="scope.row.is_drop != 0"
                            ></i>
                            #{{ scope.row.plt_order_sn }}
                            <span v-if="scope.row.redeliver_num > 0 && [5,99].includes(role)" class="deliver" @click="redeliver(scope.row)">{{ scope.row.redeliver_num }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    :label="$t('ordersList.tableName.platform_name')"
                    property="platform_name"
                    align="left"
                ></el-table-column>
                <el-table-column
                    :label="$t('ordersList.tableName.shop_name')"
                    property="shop_name"
                    align="left"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    :label="$t('ordersList.tableName.country')"
                    property="country"
                    align="left"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    :label="$t('ordersList.tableName.buyer_name')"
                    align="left"
                    width="170"
                    show-overflow-tooltip
                >
                    <template slot-scope="scoped">
                        <span>{{
                            scoped.row.user_email || scoped.row.buyer_name
                        }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    :label="$t('ordersList.tableName.order_amount')"
                    property="order_amount"
                    align="left"
                >
                    <template slot-scope="scope">
                        <span :class="`sn${scope.row.ship_cost > 0 && ' active' || ''}`"></span>
                        <span>{{
                            scope.row.currency + scope.row.order_amount
                        }}</span>
                        <span class="act-amount"
                            >({{ "$" + scope.row.act_amount }})</span
                        >
                    </template>
                </el-table-column>
                <el-table-column
                    :label="$t('ordersList.tableName.goods_num')"
                    property="goods_num"
                    align="left"
                    width="80"
                >
                    <template slot-scope="scope">
                        <span style="font-weight: bold">{{
                            scope.row.goods_num
                        }}</span>
                        <span>
                            {{
                                scope.row.goods_num > 1
                                    ? $t("ordersList.tableName.goods_items")
                                    : $t("ordersList.tableName.goods_item")
                            }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="Shipping Method"
                    property="express_name"
                    align="left"
                    :render-header="renderHeader"
                    width="140"
                >
                    <template slot-scope="scope">
                        <div class="delivery-method">
                            <el-tooltip
                                effect="dark"
                                placement="top"
                                v-if="scope.row.express_name.length > 15"
                                :content="scope.row.express_name"
                            >
                                <span class="delivery-method-name">{{
                                    scope.row.express_name
                                }}</span>
                            </el-tooltip>
                            <span v-else class="delivery-method-name">{{
                                scope.row.express_name
                            }}</span>
                            <el-tooltip
                                effect="dark"
                                placement="top"
                                v-if="scope.row.channel_code"
                                :content="scope.row.last_mile"
                            >
                                <img
                                    class="transport-icon"
                                    src="@/assets/image/transport-red.svg"
                                    v-if="scope.row.last_mile == 'Pick up from the office'"
                                />
                                <img
                                    class="transport-icon"
                                    src="@/assets/image/transport.svg"
                                    v-else
                                />
                            </el-tooltip>

                            <el-tooltip
                                effect="dark"
                                placement="top"
                                v-if="scope.row.is_sync_platfrom > 0"
                            >
                                <div slot="content" v-html="scope.row.shipped_str"></div>
                                <img
                                    class="plane-icon"
                                    src="@/assets/image/plane1.svg"
                                    v-if="scope.row.is_sync_platfrom == 1"
                                />
                                <img
                                    class="plane-icon"
                                    src="@/assets/image/plane2.svg"
                                    v-else-if="scope.row.is_sync_platfrom == 2"
                                />
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    :label="$t('ordersList.tableName.status_name')"
                    align="left"
                    width="140"
                >
                    <template slot-scope="scope">
                        <span
                            class="general-table-tag"
                            :class="[
                                scope.row.status == 1
                                    ? 'info'
                                    : scope.row.status == 10 ||
                                      scope.row.status == 20
                                    ? 'warning'
                                    : scope.row.status == 30 ||
                                      scope.row.status == 40
                                    ? 'success'
                                    : scope.row.status == 50 ||
                                      scope.row.status == 99
                                    ? 'danger'
                                    : '',
                            ]"
                        >
                            <i class="el-icon-s-help"></i>
                            {{ scope.row.status_name }}
                        </span>
                        <img
                            v-if="scope.row.is_refund != 0"
                            class="refund-icon"
                            :src="require('@/assets/image/order/refund.svg')"
                            alt="refund"
                        />
                    </template>
                </el-table-column>
                <el-table-column
                    :label="$t('ordersList.tableName.create_time')"
                    property="plt_create_time"
                    align="left"
                    width="150"
                ></el-table-column>
                <el-table-column
                    :label="$t('ordersList.tableName.operation')"
                    align="left"
                    width="150"
                    :fixed="operationFixed"
                >
                    <template slot-scope="scope">
                        <operation :scope="scope" @rowDo="rowDo"></operation>
                    </template>
                </el-table-column>
                <el-empty :image-size="120" slot="empty">
                    <img slot="image" src="@/assets/image/empty-data.svg" />
                </el-empty>
            </el-table>
        </div>
        <div id="printDv" ref="printDv" v-show="isShow" style="height: 100%">
            <div v-for="(item, index) in printData" :key="index" class="printOrder" style="page-break-before: auto; page-break-after: always;">
                <div class="print_content">
                    <div style="text-align:right;height:30px;line-height:30px;padding-right:20px;vertical-align: middle;">{{printTime}}</div>
                    <div class="title">
                        <span><img slot="image" src="@/assets/image/order/logo.png" /></span>
                        <span style="margin-left:50px">Order #{{item.plt_order_sn}}</span>
                        <span class="bt">{{item.status_name}}</span>
                    </div>
                    <div class="table-wrapper">
                        <el-table
                            ref="shippingTable"
                            :data="item.orders_goods"
                            style="width: 100%"
                            header-cell-class-name="header-cell-class-name"
                            cell-class-name="cell-class-name"
                            :cell-style="cellStyle"
                        >
                            <el-table-column
                                    label="Product Name"
                                    prop="goods_name"
                                    align="left"
                                    width="320px"
                                    show-overflow-tooltip
                                >
                                <template slot-scope="scope">
                                    {{scope.row.goods_name}}
                                    <br>
                                    <ol v-if="scope.row.custom_properties">
                                        <li v-for="(v,k) in scope.row.custom_properties" :key="k">
                                            {{k}} : {{v}}
                                        </li>
                                    </ol>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    label="SKU"
                                    prop="sku"
                                    align="center"
                                >
                                <template slot-scope="scope">
                                    <span style="font-weight:normal">{{scope.row.sku}}2</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                    label="Price"
                                    prop="goods_price"
                                    align="center"
                                >
                                <template slot-scope="scope">
                                    ${{scope.row.goods_price}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    label="Qty"
                                    prop="goods_num"
                                    align="center"
                                ></el-table-column>
                            <el-table-column
                                    label="Subtotal"
                                    prop="subtotal"
                                    align="center"
                            >
                                <template slot-scope="scope">
                                    ${{scope.row.subtotal}}
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="total">
                        <ol>
                            <li><span>Subtotal</span> <span style="padding-left:20px">${{item.subtotal}}</span></li>
                            <li><span>Shipping & Handling</span> <span style="padding-left:20px">${{item.act_ship_cost}}</span></li>
                            <li><span>Grand Total</span> <span style="padding-left:20px">${{item.grand_total}}</span></li>
                        </ol>
                    </div>
                    <div class="order-detail-body">
                        <div class="order-detail-body-item">
                            <div class="order-detail-body-label">Shipping Address</div>
                            <div class="order-detail-body-value" v-html="item.orders_address.buyer_name"></div>
                            <div class="order-detail-body-value">
                                {{
                                    item.orders_address.street1 +
                                    item.orders_address.street2
                                }}
                            </div>
                            <div class="order-detail-body-value">
                                {{
                                    item.orders_address.city +
                                    " " +
                                    item.orders_address.state +
                                    " " +
                                    item.orders_address.postal_code
                                }}
                            </div>
                            <div class="order-detail-body-value">
                                {{ item.country }}
                            </div>
                            <div class="order-detail-body-value">
                                {{ item.orders_address.phone }}
                            </div>
                            <template v-if="item.last_mile || item.tracking_number || item.shiped_time">
                                <div class="order-detail-body-label">
                                    Shipping Method
                                </div>
                                <div class="order-detail-body-value">
                                    {{ item.last_mile }}
                                    <span
                                        style="opacity: 0.8"
                                        v-if="item.express_name"
                                        >({{ item.express_name }})</span
                                    >
                                </div>
                                <div v-if="item.tracking_number"> 
                                    {{ item.tracking_number }}
                                </div>
                                <div class="order-detail-body-value" v-if="item.shiped_time">
                                    Shiped Time: {{ item.shiped_time }}
                                </div>
                            </template>
                            <template v-if="item.remark">
                                <div class="order-detail-body-label">Remark</div>
                                <div
                                    class="order-detail-body-value"
                                    v-html="item.remark"
                                >
                                </div>
                            </template>
                            <template v-if="item.ioss">
                                <div class="order-detail-body-label">IOSS</div>
                                <div class="order-detail-body-value color-danger">
                                    {{ item.ioss }}
                                </div>
                            </template>
                        </div>

                        <div class="order-detail-body-item">
                            <template v-if="item.payment_method">
                                <div class="order-detail-body-label">
                                    Payment Method
                                </div>
                                <div class="order-detail-body-value">
                                    {{ item.payment_method }}
                                </div>
                            </template>
                            <template v-if="item.customer_email">
                                <div class="order-detail-body-label">
                                    Payer Email
                                </div>
                                <div class="order-detail-body-value">
                                    {{ item.customer_email }}
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="footer">© {{printYear}} JeweLora.</div>
            </div>
            
        </div>

        <pagination
            :paginationData="paginationData"
            @paginationChange="paginationChange"
            :funcName="funcName"
        ></pagination>

        <add :addVisible.sync="addVisible" :funcName="funcName"></add>
        <edit
            :editVisible.sync="editVisible"
            :tableItem.sync="tableItem"
            :funcName="funcName"
            :orderType="orderType"
        ></edit>
        <refund
            :refundVisible.sync="refundVisible"
            :tableItem.sync="tableItem"
            :funcName="funcName"
        ></refund>
        <shipped :shippedVisible.sync="shippedVisible" :selectPltOrderSn="selectPltOrderSn" :funcName="funcName"></shipped>
        <price
            :priceVisible.sync="priceVisible"
            :tableItem.sync="tableItem"
            :funcName="funcName"
        ></price>
        <editOrderAddress
            :editVisible.sync="editAddressVisible"
            :tableItem.sync="tableItem"
            :funcName="funcName"
        ></editOrderAddress>
        <detail
            :detailVisible.sync="detailVisible"
            :tableItem.sync="tableItem"
        ></detail>
        <tracking
            :trackingVisible.sync="trackingVisible"
            :tableItem.sync="tableItem"
            :funcName="funcName"
        ></tracking>
        <wmsSteps
            :orderItem.sync="tableItem"
            :dialogTableVisible.sync="dialogTableVisible"
        ></wmsSteps>
        <exportOrder
            :exportOrderVisible.sync="exportOrderVisible"
            :tableItem.sync="tableItem"
            :funcName="funcName"
            :statusList="statusList"
        ></exportOrder>
        <reportOrder
            :reportOrderVisible.sync="reportOrderVisible"
            :funcName="funcName"
        ></reportOrder>
        <shippingMehtod
            :shippingMehtodVisible.sync="shippingMehtodVisible"
            :tableItem.sync="tableItem"
            :isBatch="isBatch"
        ></shippingMehtod>
        <paymentMethod
            :paymentMethodVisible.sync="paymentMethodVisible"
            :tableItem.sync="tableItem"
            :selectList="selectList"
            :dialogTitle="dialogTitle"
        ></paymentMethod>
        <auth
            :authVisible.sync="authVisible"
            :tableItem.sync="tableItem"
            :authKeyList.sync="authKeyList"
            @shopName="shopName"
            @shopId="shopId"
        ></auth>
        <delOrder
            :delOrderVisible.sync="delOrderVisible"
            :funcName="funcName"
        ></delOrder>
        <importPublic
            :importVisible.sync="importVisible"
            :parentFuncName="funcName"
            :methodName="['orderImport', 'orderImport2', 'orderImport4']"
            :temSrc="[
                'sale/orderImport/tpl1',
                'sale/orderImport/tpl2',
                'sale/orderImport/tpl4',
            ]"
            :title="$i18n.locale == 'zh' ? '订单导入' : 'Import Orders'"
            :needChioceTemplate="true"
        ></importPublic>
        <importTrackNo
            :importVisible.sync="importTrackNoVisible"
            :parentFuncName="funcName"
            :methodName="['importTrack']"
            :temSrc="[
                'sale/orderImport/tplTrackNo'
            ]"
            :title="'Tracking NO.'"
            :needChioceTemplate="false"
        ></importTrackNo>
        <redeliver
            :redeliverVisible.sync="redeliverVisible"
            :tableItem="tableItem"
            :funcName="funcName"
        ></redeliver>
    </div>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { infoTagsMixins } from "@/utils/infoTagsMixins.js";
import { tableMixins } from "@/utils/tableMixins.js";
import add from "./ordersList/add";
import edit from "./ordersList/edit";
import shipped from "./ordersList/shipped";
import editOrderAddress from "./ordersList/editOrderAddress";
import detail from "./ordersList/detail";
import refund from "./ordersList/refund";
import price from "./ordersList/price";
import tracking from "./ordersList/tracking";
import wmsSteps from "./ordersList/wmsStep.vue";
import exportOrder from "./ordersList/exportOrder";
import reportOrder from "./ordersList/reportOrder";
import shippingMehtod from "./ordersList/shippingMehtod.vue";
import paymentMethod from "./ordersList/paymentMethod.vue";
import auth from "./ordersList/auth";
import delOrder from "./ordersList/delOrder";
import importPublic from "@/common/components/importPublic";
import importTrackNo from "@/common/components/importPublic";
import platforms from "@/common/components/platforms.vue";
import orderThumb from "@/common/components/orderThumb.vue";
import remarkPopTable from "@/common/components/table/remarkPopTable";
import redeliver from "./ordersList/redeliver.vue";

export default {
    mixins: [infoTagsMixins, tableMixins],
    data() {
        return {
            inputPlaceholder: "Keywords include Order、Country、Customer、Buyer Name、Phone Number、Tracking NO.",
            searchForm: {
                keyword: "",
                status: "0",
                order_amount: ["", ""],
                ship_cost: ["", ""],
                created_at: "",
                payment_time: "",
                shiped_time: "",
                is_drop: "",
                shipment: "",
                high_risk: "",
                is_refund: "",
                shop_name: "",
                platform_id: "",
                last_mile: "",
                shipped:"",
                import:"",
                is_lastmile:"",
                order_source:""
                // user_email: "",
            },
            searchForm_transfer: {
                keyword: "",
                status: "0",
                order_amount: ["", ""],
                ship_cost: ["", ""],
                created_at: "",
                payment_time: "",
                shiped_time: "",
                is_drop: "",
                shipment: "",
                high_risk: "",
                is_refund: "",
                shop_name: "",
                platform_id: "",
                last_mile: "",
                shipped: "",
                import:"",
                is_lastmile:"",
                order_source:""
                // user_email: "",
            },
            advanceSearchFields: {
                platform_id: {
                    label: "Platform",
                    type: "select",
                    options: [],
                    props: {
                         multiple: true,
                    }
                },
                last_mile: {
                    label: "Shipping Method",
                    type: "select",
                    options: [],
                },
                country: {
                    label: "Country",
                    type: "select",
                    options: [],
                },
                shipped: {
                    label: "Shipped",
                    type: "select",
                    options: [],
                },
                // import:{
                //     label: "Import",
                //     type: "select",
                //     options: [],
                // },
                // lastmile:{
                //     label: "Lastmile",
                //     type: "select",
                //     options: [],
                // },
                order_source:{
                    label: "Order Source",
                    type: "select",
                    options: [],
                    props: {
                         multiple: true,
                    }
                },
                created_at: {
                    label: "Created On",
                    type: "cascader",
                },
                payment_time: {
                    label: "Payment Time",
                    type: "cascader",
                },
                shiped_time: {
                    label: "Shiped Time",
                    type: "cascader",
                },
                order_amount: {
                    label: "Order Amount",
                    type: "range",
                },
                ship_cost: {
                    label: "Ship Cost",
                    type: "range",
                },
                is_drop: {
                    label: "Drop Ship",
                    type: "checkbox",
                    options: [
                        {
                            label: "Yes",
                            value: "1",
                        },
                    ],
                },
                shipment: {
                    label: "Reshipment",
                    type: "checkbox",
                    options: [
                        {
                            label: "Yes",
                            value: "1",
                        },
                    ],
                },
                high_risk: {
                    label: "High Risk",
                    type: "checkbox",
                    options: [
                        {
                            label: "Yes",
                            value: "1",
                        },
                    ],
                },
                is_refund: {
                    label: "Refund",
                    type: "checkbox",
                    options: [
                        {
                            label: "Yes",
                            value: "1",
                        },
                    ],
                },
                is_lastmile: {
                    label: "Shipping Method",
                    type: "radio",
                    options: [
                        {
                            label: "Yes",
                            value: "1",
                        },
                        {
                            label: "No",
                            value: "-1",
                        },
                    ],
                },
                shop_name: {
                    label: "Shop Name",
                    type: "tags",
                    options: [],
                },
                
                /* user_email: {
                    label: "User Email",
                    type: "tags",
                    options: [],
                }, */
            },
            isShow: false,
            authVisible: false,
            authKeyList: [],
            addVisible: false,
            editVisible: false,
            shippedVisible: false,
            detailVisible: false,
            dialogTableVisible: false,
            exportOrderVisible: false,
            reportOrderVisible: false,
            shippingMehtodVisible: false,
            paymentMethodVisible: false,
            editAddressVisible: false,
            importVisible: false,
            importTrackNoVisible: false,
            selectList: [],
            selectPltOrderSn:[],
            countryList: [],
            shopmethodList: [],
            shop_name: "",
            shop_id: "",
            platformList: [],
            funcName: "getOrdersList",
            isBatch: false,
            dialogTitle: "",
            refundVisible: false,
            priceVisible: false,
            orderType: "",
            delOrderVisible: false,
            trackingVisible: false,
            redeliverVisible: false,
            role: 0,
            printData: [],
            printTime: "",
            printYear: "",
            shipList: [
                {
                    "name": "Yes",
                    "value": "1"
                },
                {
                    "name": "Fail",
                    "value": "2"
                },
                {
                    "name": "No",
                    "value": "-1"
                }
                
            ],
            importList: [
                {
                    "name": "Yes",
                    "value": "1"
                },
                {
                    "name": "No",
                    "value": "-1"
                }
                
            ],
            orderSourceList: [
                {
                    "name": "API",
                    "value": "0"
                },
                {
                    "name": "Manual",
                    "value": "1"
                },
                {
                    "name": "Shopping Cart",
                    "value": "2"
                }
                
            ],
        };
    },
    methods: {
        delOrder() {
            this.delOrderVisible = true;
        },
        export() {
            this.exportOrderVisible = true;
        },
        report() {
            this.reportOrderVisible = true;
        },
        redeliver(row){
            this.tableItem = row;
            this.redeliverVisible = true;
        },
        cellStyle({ row, column, rowIndex, columnIndex }) {
            if (columnIndex == 1) {
                return { fontWeight: "bold" };
            }
        },
        add() {
            this.addVisible = true;
        },
        shipped() {
            this.shippedVisible = true;
        },
        invoice(){
            if(this.selectList.length == 0){
                this.$message.warning("Please select item");
                return false;
            }

            this.printYear = (new Date()).getFullYear();
            
            cmofferApi
                .orderPrint(
                    {
                        ids:this.selectList,
                    },
                    "post"
                )
                .then((res) => {
                    this.printData = res.data;
                    this.printTime =  res.print_time;
                    this.printFun();
                });
        },
        // 打印内容
        printFun() {
            this.isShow = true;
            this.$nextTick(() =>{
                setTimeout(() => {
                    this.$print(this.$refs.printDv);
                    this.isShow = false;
                }, 100)
            })
            
        },
        handleSelectionChange(val) {
            this.selectList = [];
            this.selectPltOrderSn = [];
            for (let i in val) {
                this.selectList.push(val[i].id);
                this.selectPltOrderSn.push(val[i].plt_order_sn);
            }
        },
        renderHeader (h, {}){
            return h('div',{},[
                h('span',{},'Shipping Method '),
                h('el-tooltip', { 
                    props: { 
                        effect: 'dark',   
                        placement: 'top', 
                        content: "The red cart symbol means that the shipping method you choose is \"Pick up from the office\". \n\r Empty means that the order is not assigned logistics, If there is no other suitable shipping method available,  please contact your sales manager." 
                    }
                }, [h('i', { class:'el-icon-info',style:"font-size:14px"}, '')]
                )
            ])
        },
        clean() {
            this.searchForm = {
                keyword: "",
                status: "",
            };
            this.searchForm_transfer = {
                status: "",
                payment_time: "",
                shiped_time: "",
                order_amount: ["", ""],
                ship_cost: ["", ""],
                shop_name: "",
            };
        },
        closeDrawer() {
            this.$refs.searchTool.$refs.drawer.closeDrawer();
        },
        //获取订单table
        async getOrdersList(page) {
            this.loading = true;
            page ? (this.paginationData.page = 1) : "";
            return cmofferApi
                .orders(
                    {
                        platform: this.platform_id,
                        ...this.paginationData,
                        ...this.searchForm,
                        menu_id: this.menu_id,
                        status: this.status,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.tableData = res.data;
                        this.menuAuth = res.ext.op_auth;
                        this.statusList = res.ext.tabs;
                        /* this.advanceSearchFields.status.options =
                            res.ext.tabs.map((item) => {
                                return { label: item.name, value: item.status };
                            }); */
                        this.paginationData.total = res.total;
                        this.closeDrawer();
                        this.loading = false;
                        //this.platformList = res.ext.stat;
                        this.role = res.ext.role;
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        /**
         * table内权限按钮
         */
        rowDo(item, row) {
            if (item.status_flag == 1) {
                this.tableItem = row;
                if (item.funcName == "edit" || item.funcName == "custom") {
                    this.editVisible = true;
                    this.orderType = item.funcName;
                } else if (item.funcName == "detail") {
                    this.detailVisible = true;
                }else if (item.funcName == "tracking") {
                    this.trackingVisible = true;
                } else if (item.funcName == "editAddress") {
                    this.editAddressVisible = true;
                } else if (item.funcName == "refund") {
                    this.refundVisible = true;
                } else if (item.funcName == "price") {
                    this.priceVisible = true;
                } else if (item.funcName == "wmsSteps") {
                    this.showWmsSteps(row);
                } else if (item.funcName == "remark") {
                } else if (item.funcName == "editShippingMehtod") {
                    this.shippingMehtodVisible = true;
                    this.isBatch = false;
                } else if (item.funcName == "auth") {
                    if (row.platform_id == 3) {
                        this.authVisible = true;
                        this.authKeyList = [
                            { key: "appid", name: "AppId" },
                            { key: "secret", name: "Secret" },
                            { key: "shopname", name: "Shop Name" },
                        ];
                    } else if (row.platform_id == 4) {
                        this.authVisible = true;
                        this.authKeyList = [
                            { key: "AppKey", name: "AppKey" },
                            { key: "AppSecret", name: "AppSecret" },
                            { key: "Token", name: "Token" },
                            { key: "ShopURL", name: "Shop URL" },
                        ];
                    }
                } else if (item.funcName == "pay") {
                    this.dialogTitle = "Order Pay";
                    this.paymentMethodVisible = true;
                    this.selectList = [];
                    this.selectList.push(row.id);
                }
            } else if (item.status_flag == 2) {
                this.$prompt(`Do you want to continue?`, "Tip", {
                    inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
                    inputErrorMessage: `Please enter ${item.name}Reason`,
                    inputPlaceholder: `${item.name}Reason`,
                })
                    .then(({ value }) => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                                reason: value,
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 3) {
                this.$confirm(`Do you want to continue?`, "Tip", {
                    type: "warning",
                })
                    .then(() => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 4) {
                if (item.funcName == "delete") {
                    cmofferApi[item.parent_funcname](
                        {},
                        "delete",
                        item.rowId
                    ).then((res) => {
                        if (res) {
                            this.$message.success(`${item.name} Success`);
                            this[item.parent_funcname]();
                        }
                    });
                }
            }
        },
        batchChangeStatus(item) {
            if (this.selectList.length) {
                if (item.status_flag == 2) {
                    this.$prompt(`Do you want to continue?`, "Tip", {
                        // inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
                        inputErrorMessage: `Input ${item.name} reason`,
                        inputPlaceholder: `${item.name} reason`,
                    })
                        .then(({ value }) => {
                            cmofferApi[item.funcName](
                                {
                                    ids: this.selectList,
                                    remark: value,
                                },
                                "post"
                            ).then((res) => {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            });
                        })
                        .catch(() => {
                            // this.$message.info("已取消操作");
                        });
                } else if (item.status_flag == 3) {
                    this.$confirm(`Do you want to continue?`, "Tip", {
                        type: "warning",
                    })
                        .then(() => {
                            cmofferApi[item.funcName](
                                {
                                    ids: this.selectList,
                                },
                                "post"
                            ).then((res) => {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            });
                        })
                        .catch(() => {
                            // this.$message.info("已取消操作");
                        });
                }
            } else {
                this.$message.warning("Please select item");
            }
        },
        batchCancel() {},
        /**
         * 菜单选择
         */
        handleSelect(val) {
            this.searchForm = {
                name: "",
                status: "",
            };
            this.platform_id = val;
            this.getOrdersList();
        },
        shopName(val) {
            this.shop_name = val;
        },
        shopId(val) {
            this.shop_id = val;
        },
        authFunc(funcName) {
            this[funcName]();
        },
        batchShipping() {
            if (this.selectList.length == 0) {
                this.$message.warning(`Please select item`);
                return;
            }
            this.shippingMehtodVisible = true;
            this.isBatch = true;
        },
        batchPay() {
            if (this.selectList.length == 0) {
                this.$message.warning(`Please select item`);
                return;
            }
            this.dialogTitle = "Order Batch Pay";
            this.paymentMethodVisible = true;
        },
        import() {
            this.importVisible = true;
        },
        importTrackNo() {
            this.importTrackNoVisible = true;
        },
        searchTags(params) {
            this.searchForm[params.key] = params.value;
        },
        shop_transfer() {
            this.searchForm = Object.assign(
                this.searchForm,
                this.searchForm_transfer
            );
            this.getOrdersList();
        },
        async initialize() {
            this.getOrdersList();
            this.statForShop();
            this.platformSelect();
            this.countrySelect();
            this.lastMileSelect();
            this.shipSelect();
        },
        chiocePlatform(item) {
            this.searchForm.platform_id = item.platform_id;
            this.getOrdersList();
        },
        // 显示订单详情弹框
        showDetail(row) {
            this.detailVisible = true;
            this.tableItem = row;
        },
        showWmsSteps(row) {
            this.dialogTableVisible = true;
            this.tableItem = row;
        },
        statForShop() {
            cmofferApi
                .statForShop(
                    {
                        status: this.status,
                        platform_id: this.platform_id,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.advanceSearchFields.shop_name.options =
                            res.data.map((item) => {
                                return {
                                    label: item.shop_name,
                                    value: item.shop_id,
                                    count: item.count,
                                };
                            });
                    }
                });
        },
        statForShopUser() {
            cmofferApi
                .statForShopUser(
                    {
                        status: this.status,
                        platform_id: this.platform_id,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        // 如果接口没返回, 高级筛选不显示用户邮箱
                        if (res.data.length > 0) {
                            let userEmailObj = {
                                label: "User Email",
                                type: "tags",
                                options: [],
                            };
                            userEmailObj.options = res.data.map((item) => {
                                return {
                                    label: item.user_email,
                                    value: item.shop_id,
                                    count: item.count,
                                };
                            });
                            this.$set(
                                this.advanceSearchFields,
                                "user_email",
                                userEmailObj
                            );
                        }
                    }
                });
        },
        closeDialog() {
            this.dialogTableVisible = false;
        },
        /**
         * 平台下拉列表获取
         */
        platformSelect() {
            cmofferApi.platformSelect({}, "get").then((res) => {
                if (res) {
                    this.platformList = res.data;
                    this.advanceSearchFields.platform_id.options = this.searchList[9].props.list = this.platformList.map(item=>{
                        return {
                            label: item.name,
                            value: item.id.toString()
                        }
                    });
                }
            });
        },
        shipSelect(){
            this.advanceSearchFields.shipped.options = this.searchList[14].props.list = this.shipList.map(item=>{
                return {
                    label: item.name,
                    value: item.value.toString()
                }
            });
            // this.advanceSearchFields.import.options = this.searchList[15].props.list = this.importList.map(item=>{
            //     return {
            //         label: item.name,
            //         value: item.value.toString()
            //     }
            // });
            this.advanceSearchFields.order_source.options = this.searchList[17].props.list = this.orderSourceList.map(item=>{
                return {
                    label: item.name,
                    value: item.value.toString()
                }
            });

        },
        //国家下拉列表获取
        countrySelect() {
            cmofferApi.countrySelect({}, "get").then((res) => {
                if (res) {
                    this.countryList = res.data;
                    this.advanceSearchFields.country.options = this.searchList[10].props.list = this.countryList.map(item=>{
                        return {
                            label: item.name_en,
                            value: item.name_en
                        }
                    });
                }
            });
        },
        lastMileSelect() {
            cmofferApi.lastMileSelect({}, "get").then((res) => {
                if (res) {
                    this.shopmethodList = res.data;
                    this.advanceSearchFields.last_mile.options = this.searchList[11].props.list = this.shopmethodList.map(item=>{
                        return {
                            label: item.last_mile,
                            value: item.last_mile
                        }
                    });
                }
            });
        },
    },
    activated() {
        this.initialize();
    },
    components: {
        add,
        edit,
        shipped,
        detail,
        exportOrder,
        reportOrder,
        shippingMehtod,
        paymentMethod,
        auth,
        importPublic,
        importTrackNo,
        platforms,
        orderThumb,
        wmsSteps,
        editOrderAddress,
        refund,
        price,
        remarkPopTable,
        delOrder,
        tracking,
        redeliver,
    },
    computed: {
        height() {
            return `calc(100% - 160px${
                (this.hasSearchCondition ? " - 82px" : " - 50px") || ""
            }${
                (this.statusList instanceof Array &&
                    this.statusList.length > 0 &&
                    " - 47px") ||
                ""
            }${
                (this.platformList instanceof Array &&
                this.platformList.length > 0
                    ? " - 30px"
                    : " - 15px") || ""
            }${
                (['1', '10'].includes(this.status)
                    ? " - 58px"
                    : " - 15px") || ""
            })`;
        },
        searchList() {
            return [
                {
                    label: this.$i18n.locale == "zh" ? "关键字" : "Keyword",
                    key: "keyword",
                    type: "input",
                },
                {
                    label:
                        this.$i18n.locale == "zh" ? "创建时间" : "Created On",
                    key: "created_at",
                    type: "cascader",
                },
                {
                    label:
                        this.$i18n.locale == "zh" ? "支付时间" : "Payment Time",
                    key: "payment_time",
                    type: "cascader",
                },
                {
                    label:
                        this.$i18n.locale == "zh" ? "发货时间" : "Shiped Time",
                    key: "shiped_time",
                    type: "cascader",
                },
                {
                    label:
                        this.$i18n.locale == "zh" ? "订单数量" : "Order Amount",
                    key: "order_amount",
                    type: "range",
                },
                {
                    label: this.$i18n.locale == "zh" ? "运费" : "Ship Cost",
                    key: "ship_cost",
                    type: "range",
                },
                {
                    label: this.$i18n.locale == "zh" ? "运费" : "Drop Ship",
                    key: "is_drop",
                    type: "checkbox",
                },
                {
                    label: this.$i18n.locale == "zh" ? "退款" : "Refund",
                    key: "is_refund",
                    type: "checkbox",
                },
                {
                    label: this.$i18n.locale == "zh" ? "店铺" : "Shop Name",
                    key: "shop_name",
                    type: "tags",
                },
                /* {
                    label:
                        this.$i18n.locale == "zh" ? "用户邮箱" : "User Email",
                    key: "user_email",
                    type: "tags",
                }, */
                {
                    label: this.$i18n.locale == "zh" ? "平台" : "Platform",
                    key: "platform_id",
                    type: "select",
                    props: {
                        list: [],
                        nameKey: "keyword",
                        valueKey: "platform_id",
                    },
                },
                {
                    label: this.$i18n.locale == "zh" ? "国家" : "Country",
                    key: "country",
                    type: "select",
                    props: {
                        list: [],
                        nameKey: "keyword",
                        valueKey: "country",
                    },
                },
                {
                    label: "Shipping Method",
                    key: "last_mile",
                    type: "select",
                    props: {
                        list: [],
                        nameKey: "keyword",
                        valueKey: "last_mile",
                    },
                },
                {
                    label: "Reshipment",
                    key: "shipment",
                    type: "checkbox",
                },
                {
                    label: "High Risk",
                    key: "high_risk",
                    type: "checkbox",
                },
                {
                    label:  "Shipped",
                    key: "shipped",
                    type: "select",
                    props: {
                        list: [],
                        nameKey: "keyword",
                        valueKey: "shipped",
                    },
                },
                {
                    label:  "Import",
                    key: "import",
                    type: "select",
                    props: {
                        list: [],
                        nameKey: "keyword",
                        valueKey: "import",
                    },
                },
                {
                    label: "Shipping Method",
                    key: "is_lastmile",
                    type: "radio",
                    props: {
                        list: [
                            {
                                label: "Yes",
                                value: "1",
                            },
                            {
                                label: "No",
                                value: "-1",
                            },
                        ],
                        nameKey: "label",
                        valueKey: "value",
                    },
                },
                {
                    label:  "Order Source",
                    key: "order_source",
                    type: "select",
                    props: {
                        list: [],
                        nameKey: "keyword",
                        valueKey: "order_source",
                    },
                },
                
            ];
        },
    },
    watch: {
        searchForm: {
            handler(newValue) {
                for (let k in newValue) {
                    let v = newValue[k];
                    // v instanceof Array ? !!v.join('') newValue的值有数组时, 需要判断一下
                    if (
                        v instanceof Array
                            ? !!v.join("")
                            : !!v && k !== "status"
                    ) {
                        this.hasSearchCondition = true;
                        return;
                    }
                }
                this.hasSearchCondition = false;
            },
            deep: true,
            immediate: true,
        },
        status: {
            handler(newValue) {
                this.searchForm_transfer.status = newValue;
            },
        },
    },
};
</script>
<style lang="scss">
.ordersList {
    width: 100%;
    height: 100%;
    background: #fff;
    .table {
        margin: 0 15px !important;
        padding: 0 !important;
        width: auto !important;
        .act-amount {
            margin-left: 5px;
            color: #9b3c44;
        }
        .delivery-method {
            display: flex;
            align-items: center;
            .delivery-method-name {
                max-width: 110px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            .transport-icon {
                width: 18px;
                margin-left: 5px;
            }
            .plane-icon {
                width: 14px;
                margin-left: 5px;
            }
        }
        .refund-icon {
            width: 18px;
            margin-left: 2px;
        }
        .sn {
            border-radius: 50%;
            display: inline-block;
            width: 8px;
            height: 8px;
            background-color: #fff;
            margin-right: 3px;

            &.active {
                background-color:#9999FF;
            }
        }
        .warning {
            width: 12px;
            margin: 0 3px 5px;
        }
        .deliver{
            border: 1px solid #0404fc ;
            border-radius: 4px;
            margin-right: 3px;
            color: #0404fc;
            padding: 0 5px;
            cursor:pointer;
        }
    }
}
.printOrder{
    width: 790px;
    background: #fff;
    margin: 0px auto;
    padding: 10px;
    .title{
        text-align:left;
        height:80px;
        line-height: 80px;
        vertical-align: middle;
        font-size:20px;
        .bt{
            border: 1px solid #ccc;
            padding:2px 5px;
            margin-left:30px
        }
    }
    .total{
        height:140px;
        margin-top:20px;
        
    }
    .total ol{
        text-align:right;
    }
    .total ol li{
        height:40px;
    }
}
.print_content{
    min-height:98%;
}
.order-detail-body {
    border: 1px solid #d8d8d8;
    padding: 25px 35px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    .order-detail-body-item {
        &:not(:only-child) {
            max-width: 40%;
        }
        .tracking_number {
            font-weight: 600;
            color: $color-primary-blue;
            cursor: pointer;
            margin-bottom: 8px;
            display: inline-block;
            .el-icon-link {
                font-size: 18px;
            }
            &:active {
                opacity: 0.8;
            }
        }
    }
    .order-detail-body-title {
        font-size: 17px;
        font-weight: bold;
        margin-bottom: 20px;
    }
    .order-detail-body-label {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
    }
    .order-detail-body-value {
        font-size: 16px;
        margin-bottom: 8px;
        line-height: 20px;
    }

    .order-detail-body-value + .order-detail-body-label {
        margin-top: 20px;
    }
}

.el-tooltip__popper {
    width: auto;
}
.footer{
    height:40px;
    line-height: 40px;
    text-align: center;
    margin-top: -60px;
}

</style>
